import { render, staticRenderFns } from "./NivelElevado.vue?vue&type=template&id=be6bb698&scoped=true"
import script from "./NivelElevado.vue?vue&type=script&lang=js"
export * from "./NivelElevado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6bb698",
  null
  
)

export default component.exports